import { forwardRef, type SelectHTMLAttributes } from 'react';

type SelectSize = 'sm' | 'md';

interface SelectProps extends Omit<SelectHTMLAttributes<HTMLSelectElement>, 'size'> {
  size?: SelectSize;
  active?: boolean;
}

const sizeClass: Record<SelectSize, string> = {
  sm: 'px-2.5 py-1.5 text-[11px] tracking-wide rounded-md',
  md: 'px-3 py-2 text-sm rounded-lg',
};

export const Select = forwardRef<HTMLSelectElement, SelectProps>(
  ({ size = 'md', active = false, className = '', style, ...props }, ref) => {
    return (
      <select
        ref={ref}
        className={`form-input border font-medium ${sizeClass[size]} ${className}`}
        style={{
          fontFamily: 'var(--font-mono)',
          borderColor: active ? 'var(--color-brand)' : 'var(--color-border-2)',
          backgroundColor: active ? 'var(--color-brand-dim)' : 'var(--color-surface)',
          color: active ? 'var(--color-brand)' : 'var(--color-text-2)',
          ...style,
        }}
        {...props}
      />
    );
  },
);

Select.displayName = 'Select';
